export const RELATED_ENTITIES_HEADER_ICON_SIZE_PX = 16;

export const RELATED_ENTITIES_EXCEL_SHEET_NAME = "Relations";

export const RELATED_ENTITIES_IDS_JOIN_DELIMITER = ", ";

export const RELATED_ENTITIES_DRAWER_WIDTH_PX = 644;

export const RELATED_ENTITIES_COUNT_SEPARATOR = "·";

/** Wait for menu-drawer open tween before showing the content loader. */
export const RELATED_ENTITIES_DRAWER_OPEN_MS = 450;
